import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { PatientGroup } from './PatientGroupField.types';
import { getPatientGroupsFilterSearchParamValue } from './PatientGroupField.utils';
import { patientGroupFilterStorage } from './PatientGroupField.storage';

export const usePatientGroupTriggerLabelExtractor = (
   patientGroups: PatientGroup[]
): ((currentPatientGroups: PatientGroup[]) => string) => {
   const translate = useTranslate();

   return useCallback(
      (currentPatientGroups) => {
         if (!currentPatientGroups.length) {
            return translate(appointmentsTranslationKeys.patientGroupFilter.selectPatientGroups);
         }
         return translate(
            createInterpolatedTranslationKey(appointmentsTranslationKeys.patientGroupFilter.chosenOf, {
               count: currentPatientGroups.length,
               totalCount: patientGroups.length,
            })
         );
      },
      [patientGroups, translate]
   );
};

export const usePatientGroupFilterSearchParamHandler = (currentFilter: PatientGroup[]): VoidFunction => {
   const history = useHistory();
   const location = useLocation();

   return useCallback(() => {
      const searchParams = new URLSearchParams(location.search);
      const patientGroupsIdsFilterValue = getPatientGroupsFilterSearchParamValue(currentFilter);

      if (currentFilter.length) {
         searchParams.set(visitPaths.PATIENT_GROUP_SEARCH_PARAM, patientGroupsIdsFilterValue);
         patientGroupFilterStorage.setFilter(patientGroupsIdsFilterValue);
      }

      if (!currentFilter.length) {
         searchParams.delete(visitPaths.PATIENT_GROUP_SEARCH_PARAM);
         patientGroupFilterStorage.removeFilter();
      }

      return history.replace({ search: searchParams.toString(), state: location.state });
   }, [currentFilter, history, location.search, location.state]);
};
